module.exports = __webpack_public_path__ + "img/cart.3e79f18d.svg";